import base from './base';

const evaluationApi = dispatch => {
  return {
    async getAvailableCodes2(search) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/codes/search2=${search}`,
        method: 'get',
      });
      return response;
    },

    async getAvailableCodes(search) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/codes/search=${search}`,
        method: 'get',
      });
      return response;
    },

    async getChartMetaByType(method) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/meta/${method}`,
        method: 'get',
      });
      return response;
    },

    async getEvaluationCode(code, method) {
      const response = await base.privateApi(dispatch, {
        path: `/evaluation/${code}/${method}`,
        method: 'get',
      });
      return response;
    },

    async getDCACode(code) {
      const response = await base.privateApi(dispatch, {
        path: `/chart/dca/code/${code}`,
        method: 'get',
      });
      return response;
    },
  };
};

export default evaluationApi;
